export default __webpack_public_path__ + "static/media/login_left_img.91b076fd.svg";